import { render } from "./playerinfo.vue?vue&type=template&id=192c79fa&scoped=true"
import script from "./playerinfo.vue?vue&type=script&lang=js"
export * from "./playerinfo.vue?vue&type=script&lang=js"

import "./playerinfo.vue?vue&type=style&index=0&id=192c79fa&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-192c79fa"]])

export default __exports__